import { graphql } from "react-relay";

export const QUERY = graphql`
	query academiesTags_Query {
		...academiesTagsTable_QueryFragment
	}
`;
